
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { useResourceStats } from '@/hooks/useResourceStats';

const ResourceSidebarStats: React.FC = () => {
  const { data: stats, isLoading } = useResourceStats();

  if (isLoading) {
    return (
      <>
        {/* Community Stats */}
        <Card>
          <CardHeader>
            <CardTitle className="text-lg">Community Stats</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            {[1, 2, 3, 4].map((i) => (
              <div key={i} className="flex justify-between items-center">
                <Skeleton className="h-4 w-24" />
                <Skeleton className="h-4 w-12" />
              </div>
            ))}
          </CardContent>
        </Card>

        {/* Popular Categories */}
        <Card>
          <CardHeader>
            <CardTitle className="text-lg">Popular Categories</CardTitle>
          </CardHeader>
          <CardContent className="space-y-3">
            {[1, 2, 3, 4].map((i) => (
              <div key={i} className="flex items-center justify-between">
                <Skeleton className="h-4 w-32" />
                <Skeleton className="h-4 w-16" />
              </div>
            ))}
          </CardContent>
        </Card>
      </>
    );
  }

  if (!stats) return null;

  return (
    <>
      {/* Community Stats */}
      <Card>
        <CardHeader>
          <CardTitle className="text-lg">Community Stats</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="flex justify-between items-center">
            <span className="text-sm text-muted-foreground">Total Resources</span>
            <span className="font-semibold">{stats.totalResources}</span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-sm text-muted-foreground">AI Tools Listed</span>
            <span className="font-semibold">{stats.aiTools}</span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-sm text-muted-foreground">Prompt Templates</span>
            <span className="font-semibold">{stats.templates}</span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-sm text-muted-foreground">Video Tutorials</span>
            <span className="font-semibold">{stats.videos}</span>
          </div>
        </CardContent>
      </Card>

      {/* Popular Categories */}
      <Card>
        <CardHeader>
          <CardTitle className="text-lg">Popular Categories</CardTitle>
        </CardHeader>
        <CardContent className="space-y-3">
          {stats.categoryStats.slice(0, 4).map((category) => (
            <div key={category.name} className="flex items-center justify-between">
              <span className="text-sm">{category.icon} {category.name}</span>
              <span className="text-xs text-muted-foreground">
                {category.count} resource{category.count !== 1 ? 's' : ''}
              </span>
            </div>
          ))}
        </CardContent>
      </Card>
    </>
  );
};

export default ResourceSidebarStats;
